/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Dokumentation } from '../models/dokumentation';
import { DokumentationReference } from '../models/dokumentation-reference';
import { DokumentationVejledning } from '../models/dokumentation-vejledning';
import { ProjektBilag } from '../models/projekt-bilag';
import { DokumentationBilag } from '../models/dokumentation-bilag';
import { SagMstVilkaarBilag } from '../models/sag-mst-vilkaar-bilag';
@Injectable({
  providedIn: 'root',
})
class DokumentationerService extends __BaseService {
static readonly getDokumentationPath = '/dokumentationer';
static readonly getDokumentationVejledningPath = '/dokumentationer/vejledning';
static readonly saveDokumentationPath = '/dokumentationer/save';
static readonly addBilagPath = '/dokumentationer/{id}/bilag';
static readonly removeDokumentationBilagPath = '/dokumentationer/{id}/bilag/fjern';
static readonly addVilkaarBilagPath = '/dokumentationer/add-vilkaar-bilag';
static readonly removeVilkaarBilagPath = '/dokumentationer/fjern-vilkaar-bilag';
static readonly genbrugDokumentationPath = '/dokumentationer/{id}/genbrug';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Gets the dokumentation.
   * @param params The `DokumentationerService.GetDokumentationParams` containing the following parameters:
   *
   * - `genbrugFromDokumentationId`:
   *
   * - `dokumentationReference`:
   *
   * @return Success
   */
  private getDokumentationResponse(params: DokumentationerService.GetDokumentationParams): __Observable<__StrictHttpResponse<Dokumentation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.genbrugFromDokumentationId != null) __params = __params.set('genbrugFromDokumentationId', params.genbrugFromDokumentationId.toString());
    __body = params.dokumentationReference;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/dokumentationer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dokumentation>;
      })
    );
  }

  /**
   * Gets the dokumentation.
   * @param params The `DokumentationerService.GetDokumentationParams` containing the following parameters:
   *
   * - `genbrugFromDokumentationId`:
   *
   * - `dokumentationReference`:
   *
   * @return Success
   */
  getDokumentation(params: DokumentationerService.GetDokumentationParams): __Observable<Dokumentation> {
    return this.getDokumentationResponse(params).pipe(
      __map(_r => _r.body as Dokumentation)
    );
  }

  /**
   * @param params The `DokumentationerService.GetDokumentationVejledningParams` containing the following parameters:
   *
   * - `regelKonfigurationId`:
   *
   * - `organisationId`:
   *
   * - `dokumentationTypeKode`:
   *
   * - `dokumentationTypeId`:
   *
   * @return Success
   */
  private getDokumentationVejledningResponse(params: DokumentationerService.GetDokumentationVejledningParams): __Observable<__StrictHttpResponse<DokumentationVejledning>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.regelKonfigurationId != null) __params = __params.set('regelKonfigurationId', params.regelKonfigurationId.toString());
    if (params.organisationId != null) __params = __params.set('organisationId', params.organisationId.toString());
    if (params.dokumentationTypeKode != null) __params = __params.set('dokumentationTypeKode', params.dokumentationTypeKode.toString());
    if (params.dokumentationTypeId != null) __params = __params.set('dokumentationTypeId', params.dokumentationTypeId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/dokumentationer/vejledning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DokumentationVejledning>;
      })
    );
  }

  /**
   * @param params The `DokumentationerService.GetDokumentationVejledningParams` containing the following parameters:
   *
   * - `regelKonfigurationId`:
   *
   * - `organisationId`:
   *
   * - `dokumentationTypeKode`:
   *
   * - `dokumentationTypeId`:
   *
   * @return Success
   */
  getDokumentationVejledning(params: DokumentationerService.GetDokumentationVejledningParams): __Observable<DokumentationVejledning> {
    return this.getDokumentationVejledningResponse(params).pipe(
      __map(_r => _r.body as DokumentationVejledning)
    );
  }

  /**
   * Saves the dokumentation.
   * @param params The `DokumentationerService.SaveDokumentationParams` containing the following parameters:
   *
   * - `genbrugFromDokumentationId`:
   *
   * - `dokumentation`:
   *
   * - `aendretAfSignering`:
   *
   * @return Success
   */
  private saveDokumentationResponse(params: DokumentationerService.SaveDokumentationParams): __Observable<__StrictHttpResponse<Dokumentation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.genbrugFromDokumentationId != null) __params = __params.set('genbrugFromDokumentationId', params.genbrugFromDokumentationId.toString());
    __body = params.dokumentation;
    if (params.aendretAfSignering != null) __params = __params.set('aendretAfSignering', params.aendretAfSignering.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/dokumentationer/save`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dokumentation>;
      })
    );
  }

  /**
   * Saves the dokumentation.
   * @param params The `DokumentationerService.SaveDokumentationParams` containing the following parameters:
   *
   * - `genbrugFromDokumentationId`:
   *
   * - `dokumentation`:
   *
   * - `aendretAfSignering`:
   *
   * @return Success
   */
  saveDokumentation(params: DokumentationerService.SaveDokumentationParams): __Observable<Dokumentation> {
    return this.saveDokumentationResponse(params).pipe(
      __map(_r => _r.body as Dokumentation)
    );
  }

  /**
   * Adds projekt bilag to the dokumentation.
   * @param params The `DokumentationerService.AddBilagParams` containing the following parameters:
   *
   * - `sagId`: Sagid.
   *
   * - `projektVersionNr`: version.
   *
   * - `projektId`: Projektid.
   *
   * - `id`: id.
   *
   * - `bilagList`: The bilag.
   *
   * @return Success
   */
  private addBilagResponse(params: DokumentationerService.AddBilagParams): __Observable<__StrictHttpResponse<Dokumentation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sagId != null) __params = __params.set('sagId', params.sagId.toString());
    if (params.projektVersionNr != null) __params = __params.set('projektVersionNr', params.projektVersionNr.toString());
    if (params.projektId != null) __params = __params.set('projektId', params.projektId.toString());

    __body = params.bilagList;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/dokumentationer/${encodeURIComponent(String(params.id))}/bilag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dokumentation>;
      })
    );
  }

  /**
   * Adds projekt bilag to the dokumentation.
   * @param params The `DokumentationerService.AddBilagParams` containing the following parameters:
   *
   * - `sagId`: Sagid.
   *
   * - `projektVersionNr`: version.
   *
   * - `projektId`: Projektid.
   *
   * - `id`: id.
   *
   * - `bilagList`: The bilag.
   *
   * @return Success
   */
  addBilag(params: DokumentationerService.AddBilagParams): __Observable<Dokumentation> {
    return this.addBilagResponse(params).pipe(
      __map(_r => _r.body as Dokumentation)
    );
  }

  /**
   * @param params The `DokumentationerService.RemoveDokumentationBilagParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `bilag`:
   */
  private removeDokumentationBilagResponse(params: DokumentationerService.RemoveDokumentationBilagParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.bilag;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/dokumentationer/${encodeURIComponent(String(params.id))}/bilag/fjern`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param params The `DokumentationerService.RemoveDokumentationBilagParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `bilag`:
   */
  removeDokumentationBilag(params: DokumentationerService.RemoveDokumentationBilagParams): __Observable<null> {
    return this.removeDokumentationBilagResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `DokumentationerService.AddVilkaarBilagParams` containing the following parameters:
   *
   * - `vilkaarId`:
   *
   * - `bilag`:
   *
   * @return Success
   */
  private addVilkaarBilagResponse(params: DokumentationerService.AddVilkaarBilagParams): __Observable<__StrictHttpResponse<SagMstVilkaarBilag>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.vilkaarId != null) __params = __params.set('vilkaarId', params.vilkaarId.toString());
    __body = params.bilag;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/dokumentationer/add-vilkaar-bilag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SagMstVilkaarBilag>;
      })
    );
  }

  /**
   * @param params The `DokumentationerService.AddVilkaarBilagParams` containing the following parameters:
   *
   * - `vilkaarId`:
   *
   * - `bilag`:
   *
   * @return Success
   */
  addVilkaarBilag(params: DokumentationerService.AddVilkaarBilagParams): __Observable<SagMstVilkaarBilag> {
    return this.addVilkaarBilagResponse(params).pipe(
      __map(_r => _r.body as SagMstVilkaarBilag)
    );
  }

  /**
   * @param bilag undefined
   */
  private removeVilkaarBilagResponse(bilag?: SagMstVilkaarBilag): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = bilag;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/dokumentationer/fjern-vilkaar-bilag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param bilag undefined
   */
  removeVilkaarBilag(bilag?: SagMstVilkaarBilag): __Observable<null> {
    return this.removeVilkaarBilagResponse(bilag).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `DokumentationerService.GenbrugDokumentationParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `includeBilag`:
   *
   * @return Success
   */
  private genbrugDokumentationResponse(params: DokumentationerService.GenbrugDokumentationParams): __Observable<__StrictHttpResponse<Dokumentation>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.includeBilag != null) __params = __params.set('includeBilag', params.includeBilag.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/dokumentationer/${encodeURIComponent(String(params.id))}/genbrug`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Dokumentation>;
      })
    );
  }

  /**
   * @param params The `DokumentationerService.GenbrugDokumentationParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `includeBilag`:
   *
   * @return Success
   */
  genbrugDokumentation(params: DokumentationerService.GenbrugDokumentationParams): __Observable<Dokumentation> {
    return this.genbrugDokumentationResponse(params).pipe(
      __map(_r => _r.body as Dokumentation)
    );
  }
}

module DokumentationerService {

  /**
   * Parameters for getDokumentation
   */
  export interface GetDokumentationParams {
    genbrugFromDokumentationId?: string;
    dokumentationReference?: DokumentationReference;
  }

  /**
   * Parameters for getDokumentationVejledning
   */
  export interface GetDokumentationVejledningParams {
    regelKonfigurationId?: string;
    organisationId?: string;
    dokumentationTypeKode?: string;
    dokumentationTypeId?: string;
  }

  /**
   * Parameters for saveDokumentation
   */
  export interface SaveDokumentationParams {
    genbrugFromDokumentationId?: string;
    dokumentation?: Dokumentation;
    aendretAfSignering?: boolean;
  }

  /**
   * Parameters for addBilag
   */
  export interface AddBilagParams {

    /**
     * Sagid.
     */
    sagId: string;

    /**
     * version.
     */
    projektVersionNr: number;

    /**
     * Projektid.
     */
    projektId: string;

    /**
     * id.
     */
    id: string;

    /**
     * The bilag.
     */
    bilagList: Array<ProjektBilag>;
  }

  /**
   * Parameters for removeDokumentationBilag
   */
  export interface RemoveDokumentationBilagParams {
    id: string;
    bilag?: DokumentationBilag;
  }

  /**
   * Parameters for addVilkaarBilag
   */
  export interface AddVilkaarBilagParams {
    vilkaarId?: string;
    bilag?: ProjektBilag;
  }

  /**
   * Parameters for genbrugDokumentation
   */
  export interface GenbrugDokumentationParams {
    id: string;
    includeBilag?: boolean;
  }
}

export { DokumentationerService }
